import type { FieldError } from 'react-hook-form'
import type { IntlShape } from 'react-intl'

import { fieldErrorText } from '@/components/form'
import { extractValidationFieldErrors } from '@/utils/extract-validation-detail'

/** Coupon-form field errors: `coupon.*` keys are formatted, raw server strings render verbatim. */
export const couponErrorText = (
  formatMessage: IntlShape['formatMessage'],
  error: FieldError | undefined,
): string | undefined => fieldErrorText(formatMessage, error, 'coupon.')

/**
 * Whether a coupon mutation error should surface as the dialog's generic banner.
 * A pure `code`-field 422 is already shown on the code field (see
 * `useCouponCodeServerError`), so it stays quiet for that case; any other failure
 * — a non-`code` field error, a service-level 422, or a non-422 (500 / missing
 * endpoint) — needs the banner so the operator isn't left with no feedback.
 */
export const showsGenericCouponError = (serverError: unknown): boolean => {
  if (serverError == null) {
    return false
  }
  const fieldErrors = extractValidationFieldErrors(serverError)
  if (fieldErrors === null) {
    return true
  }

  return fieldErrors.some((entry) => entry.field !== 'code')
}
